import { Box } from "@mui/material";
import { Component, ReactNode } from "react";

import { ErrorPageContent } from "./EdmError";

type ErrorBoundaryProps = { children: ReactNode };
type ErrorBoundaryState = { hasError: boolean };

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    console.error("Caught error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box mt={8}>
          <ErrorPageContent />
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
